import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from './Layout';
import { VaultGate } from './VaultGate';
import { ErrorBanner } from './ErrorBanner';
import { Placeholder } from '../screens/Placeholder';
import { SettingsScreen } from '../screens/SettingsScreen';
import { HomeScreen } from '../screens/HomeScreen';
import { ClientsScreen } from '../screens/ClientsScreen';
import { ClientShell } from '../screens/client/ClientShell';
import { ClientOverview } from '../screens/client/ClientOverview';
import { ClientProfile } from '../screens/client/ClientProfile';
import { BriefScreen } from '../screens/client/BriefScreen';
import { FormulationScreen } from '../screens/client/FormulationScreen';
import { TreatmentScreen } from '../screens/client/TreatmentScreen';
import { GoalsScreen } from '../screens/client/GoalsScreen';
import { DiagnosisScreen } from '../screens/client/DiagnosisScreen';
import { AssessmentsScreen } from '../screens/client/AssessmentsScreen';
import { DocumentsScreen } from '../screens/client/DocumentsScreen';
import { SessionNewScreen } from '../screens/session/SessionNewScreen';
import { SessionScreen } from '../screens/session/SessionScreen';
import { JournalScreen } from '../screens/session/JournalScreen';
import { VerifyScreen } from '../screens/session/VerifyScreen';
import { AiScreen } from '../screens/session/AiScreen';
import { RunScreen, RunStartScreen } from '../screens/session/RunScreen';
import { RunPickScreen } from '../screens/RunPickScreen';
import { SearchScreen } from '../screens/SearchScreen';
import { TimelineScreen } from '../screens/client/TimelineScreen';


const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <HomeScreen /> },
      { path: '/clients', element: <ClientsScreen /> },
      {
        path: '/clients/:clientId',
        element: <ClientShell />,
        children: [
          { index: true, element: <ClientOverview /> },
          { path: 'timeline', element: <TimelineScreen /> },
          { path: 'formulation', element: <FormulationScreen /> },
          { path: 'treatment', element: <TreatmentScreen /> },
          { path: 'goals', element: <GoalsScreen /> },
          { path: 'diagnosis', element: <DiagnosisScreen /> },
          { path: 'assessments', element: <AssessmentsScreen /> },
          { path: 'documents', element: <DocumentsScreen /> },
          { path: 'profile', element: <ClientProfile /> },
        ],
      },
      { path: '/clients/:clientId/brief', element: <BriefScreen /> },
      { path: '/clients/:clientId/run', element: <RunStartScreen /> },
      { path: '/run', element: <RunPickScreen /> },
      { path: '/sessions/:sessionId/run', element: <RunScreen /> },
      { path: '/sessions/new', element: <SessionNewScreen /> },
      { path: '/sessions/:sessionId', element: <SessionScreen /> },
      { path: '/sessions/:sessionId/journal', element: <JournalScreen /> },
      { path: '/sessions/:sessionId/verify', element: <VerifyScreen /> },
      { path: '/sessions/:sessionId/ai', element: <AiScreen /> },
      { path: '/search', element: <SearchScreen /> },
      { path: '/settings', element: <SettingsScreen /> },
      {
        path: '*',
        element: <Placeholder screen={{ path: '*', title: '페이지를 찾을 수 없습니다', milestone: '-' }} />,
      },
    ],
  },
]);

export function App() {
  return (
    <>
      <ErrorBanner />
      <VaultGate>
        <RouterProvider router={router} />
      </VaultGate>
    </>
  );
}
